module.exports = __webpack_public_path__ + "img/inhalt_pic.826946d9.jpg";